import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import Footer from './Components/Footer';
import Mission from './Components/Mission';
import Events from './Components/Events';
import Action from './Components/Action';
import { Contact } from './Components/Contact';
import About from './Components/About';
import Gallery from './Components/Gallery';
import Majengo from './Locations/Majengo';
import Thome from './Locations/thome';
import Korogocho from './Locations/Korogocho';
import Korogocho2 from './Locations/Korogocho2';
import Soweto from './Locations/Soweto';
import Donate from './Components/Donate';
import Modal from './Components/Modal';

function App() {
  const [showModal, setShowModal] = useState(true);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/about" element={<About />} />
          <Route path="/events" element={<Events />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/action" element={<Action />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/majengo" element={<Majengo />} />
          <Route path="/korogocho" element={<Korogocho />} />
          <Route path="/korogocho2" element={<Korogocho2 />} />
          <Route path="/soweto" element={<Soweto />} />
          <Route path="/thome" element={<Thome />} />
        </Routes>
        <Footer />
        {showModal && <Modal onClose={handleCloseModal} />} 
      </div>
    </Router>
  );
}

export default App;
